<div class="relative h-full w-full">
  <canvas #chart></canvas>
</div>

@if (loading() || noData()) {
  <div
    class="bg-background/50 absolute inset-0 z-10 flex items-center justify-center rounded-xl backdrop-blur-xs"
  >
    @if (loading()) {
      <knx-spinner></knx-spinner>
    } @else {
      <knx-empty>
        {{ 'app.noData' | translate }}
      </knx-empty>
    }
  </div>
}
